import { render, staticRenderFns } from "./InstagramCommentShow.vue?vue&type=template&id=084f9476"
import script from "./InstagramCommentShow.vue?vue&type=script&lang=js"
export * from "./InstagramCommentShow.vue?vue&type=script&lang=js"
import style0 from "./InstagramCommentShow.vue?vue&type=style&index=0&id=084f9476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports